/*
 * Highlight-text reveal.
 * Adds the `animate` class to any `.highlight-text` element when it scrolls
 * into view, which triggers the draw / grow animation defined in
 * highlight-text.css. Uses a plain IntersectionObserver (no customized
 * built-in element) so it works in Safari as well as Chrome/Firefox.
 */
(function () {
  function reveal(el) {
    el.classList.add('animate');
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('.highlight-text:not(.animate)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }

  // Re-scan when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
